import { ThemeProvider } from '@mui/material'
import { createTheme } from '@mui/system'
import { Route, Routes } from 'react-router-dom'
import './App.css'
import Layout from './components/Layout'
import About from './components/pages/About'
import Contact from './components/pages/Contact'
import DrawerAppBar from './components/pages/DrawerAppBar'
import Features from './components/pages/Features'
import Footer from './components/pages/Footer'
import HeroSection from './components/pages/HeroSection'
import Navbar from './components/pages/Navbar'
import Services from './components/pages/Services'

const theme = createTheme({
  typography: {
    // fontFamily: 'montserrat',
    fontFamily: 'Montserrat Ace',
  },
  // overrides: {
  //   MuiCssBaseline: {
  //     '@global': {
  //       '@font-face': [raleway],
  //     },
  //   },
  // },
})
function App() {
  return (
    <>
      <DrawerAppBar />
      <ThemeProvider theme={theme}>
        <div className='App'>
          <Routes>
            <Route
              path='/'
              index
              element={
                <Layout>
                  <section className='nav-sec'>
                    {/* <Navbar /> */}
                    {/* <DrawerAppBar /> */}
                    <HeroSection />
                  </section>
                  {/* <About /> */}
                  <Services />
                  <Footer />
                </Layout>
              }
            />
            <Route
              path='/home'
              element={
                <Layout>
                  <section className='nav-sec'>
                    {/* <Navbar /> */}
                    {/* <DrawerAppBar /> */}
                    <HeroSection />
                  </section>
                  {/* <About /> */}
                  <Services />
                  <Footer />
                </Layout>
              }
            />

            <Route
              path='/about'
              element={
                <Layout>
                  <section className='nav-sec'>
                    {/* <Navbar /> */}
                    {/* <HeroSection /> */}
                  </section>
                  <About />
                  {/* <Services /> */}
                  <Footer />
                </Layout>
              }
            />
            <Route
              path='/features'
              element={
                <Layout>
                  <section className='nav-sec'>
                    {/* <Navbar /> */}
                    {/* <HeroSection /> */}
                  </section>
                  <Features />
                  {/* <About /> */}
                  {/* <Services /> */}
                  <Footer />
                </Layout>
              }
            />
            <Route
              path='/contact'
              element={
                <Layout>
                  <section className='nav-sec'>
                    {/* <Navbar /> */}
                    {/* <HeroSection /> */}
                  </section>
                  {/* <About /> */}
                  <Contact />
                  {/* <Services /> */}
                  <Footer />
                </Layout>
              }
            />
          </Routes>
          {/* <section className='nav-sec'>
        <Navbar />
        <HeroSection />
      </section>
      <About />
      <Services />
      <Footer /> */}
        </div>
      </ThemeProvider>
    </>
  )
}

export default App
